
import {mapState} from 'vuex'
import { message as alertMessage } from "ant-design-vue";
alertMessage.config({
  top: "60px",
  duration: 2,
  maxCount: 3,
});
export default {
  props: ["name", "code", "logo", "id", "fanpage_id"],
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      BASE_URL_AUTH_REDIRECT: this.$config.BASE_URL_AUTH_REDIRECT,
      BASE_URL_CLIENT: this.$config.BASE_URL_CLIENT,
      mediaUrl: this.$config.BASE_URL_RESOURCE,
      socials: [
        {
          name: "Facebook",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/4631826c0d884bdb95a8657c5ff558f8.png`,
        },
        {
          name: "Instagram",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/e9c7d37f5b314a2fb032da5acb96da94.png`,
        },

        {
          name: "LinkedIn",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/3e5efad6d085486fb081810b4e63a968.png`,
        },
        {
          name: "Twitter",
          src: `${this.$config.BASE_URL_STATIC}/storages/2025-08-14/0fb65979bfd945808ba40e92a3a4f930.png`,
        },
      ],
    };
  },

  computed: {
    ...mapState(["userInfo", "loggedIn"]),
    ...mapState("SchoolAccount", ["accountSchoolId", "userRole"]),
    authLoading() {
      return this.$store.state.authLoading;
    },
    isSchoolSaved() {
      let listSchoolSaved = this.$store.state.listSchoolSaved.map(
        (item) => item
      );
      const itemExisted = listSchoolSaved.find((item) => {
        if (item.id === this.id) {
          return true;
        }
        return false;
      });
      return itemExisted !== undefined ? true : false;
    },
  },
  methods: {
    notify(message){
      alertMessage.warning(message)
    },
    onSaveSchool(id) {
      this.$store.dispatch("saveSchool", {
        schoolId: id,
      });
    },
    handleChat() {
      if(this.userRole && this.userRole.length>0){
        this.notify('Không thể dùng tài khoản trường để trao đổi với trường khác')
        return;
      }
      if(!this.loggedIn){
        const urlRedirectLogin = `${this.BASE_URL_AUTH_REDIRECT}/auth/login?redirectUrl=${encodeURI(`${this.BASE_URL_CLIENT}${this.$route.fullPath}`)}`;
      console.log({urlRedirectLogin})
      window.location.href = urlRedirectLogin;
      return;
      }
      const list_room = this.$store.state.Chat.list_room;
      const room_existed = list_room.find((item) => item.name === this.name);
      console.log({room_existed})
      if (room_existed) {
        this.$store.commit("Chat/SET_CHAT_ROOM_SELECTED", {
          room_id: room_existed.id,
          name: room_existed.name,
          avatar: `${this.mediaUrl}${this.logo}`,
          current_pro_id: room_existed.current_pro_id,
        });
     
      } else {
  
        if(!this.fanpage_id || this.fanpage_id.length===0){
          return;
        }
        this.$store.commit("Chat/SET_CHAT_ROOM_TEMPORARY", {
          name: this.name,
          avatar: `${this.mediaUrl}${this.logo}`,
          fanpage_id: this.fanpage_id,
        });
      }
      this.$router.push({ path: "/user?p=chat" });
      }
      
  },
};
